module.exports = __webpack_public_path__ + "static/media/file-medical.311b7cc2.svg";